import {useSignal, useSignals} from '@preact/signals-react/runtime'
import {Button} from 'primereact/button'
import {Sidebar} from 'primereact/sidebar'
import {forwardRef, useImperativeHandle} from 'react'
import TranslateUtils from '../../../i18n/TranslateUtils'
import {convertKeyToLabel} from '../../table-utils/TableUtils'
import {
    patientColumnHeaderReferenceList,
    valueType,
} from './PatientTableConstants'

const ColumnHeaderReference = forwardRef((props, ref) => {
    useSignals()
    useImperativeHandle(ref, () => ({
        showForm: handleShowForm,
        hideForm: handleHideForm,
    }))

    const {translateDatatable} = TranslateUtils()

    const visible = useSignal(false)

    const handleShowForm = () => {
        visible.value = true
    }

    const handleHideForm = () => {
        visible.value = false
    }

    const renderHeaderTable = () => {
        const tableHeaderColumn = [
            'column',
            'valueType',
            'description',
            'acceptedValues',
            'example',
        ]

        return (
            <tr>
                {tableHeaderColumn &&
                    tableHeaderColumn?.length > 0 &&
                    tableHeaderColumn?.map((headerCol, idx) => (
                        <th
                            key={idx}
                            className="border-bottom-2 border-1 border-500 p-2 text-left">
                            {convertKeyToLabel(headerCol).toUpperCase()}
                        </th>
                    ))}
            </tr>
        )
    }

    const renderBodyTable = () => {
        return (
            <>
                {patientColumnHeaderReferenceList &&
                    patientColumnHeaderReferenceList?.length > 0 &&
                    patientColumnHeaderReferenceList?.map((col, idx) => (
                        <tr
                            key={col?.column}
                            className={`${idx % 2 ? 'surface-100' : ''}`}>
                            {Object.keys(col).map(colKey => (
                                <td
                                    key={`${colKey}-${idx}`}
                                    className="border-1 border-400 p-2 text-left">
                                    {col['valueType'] === valueType.enum ? (
                                        colKey === 'acceptedValues' ? (
                                            <div>
                                                <p className="text-left">
                                                    {col[colKey].join(' / ')}
                                                </p>
                                            </div>
                                        ) : (
                                            col[colKey]
                                        )
                                    ) : (
                                        col[colKey]
                                    )}
                                </td>
                            ))}
                        </tr>
                    ))}
            </>
        )
    }

    return (
        <Sidebar
            id="sidebar-advanced-filter"
            fullScreen
            className="sidebar-filter"
            visible={visible.value}
            onHide={handleHideForm}
            baseZIndex={300}
            showCloseIcon={true}
            blockScroll
            position="right">
            <div className="py-2 px-1 w-full">
                {/* Header */}
                <div className="flex align-items-center">
                    <div className="mr-2">
                        <i
                            className="pi pi-align-left m-0"
                            style={{fontSize: '26px'}}
                        />
                    </div>
                    <div>
                        <h3 className="font-bold m-0">
                            Column Header Reference
                        </h3>
                    </div>
                </div>
                <div>
                    <p>
                        This contains accepted headers and column values, this
                        refers to a structured document or system that defines
                        both the allowed headers (the names of the columns) and
                        the expected types of values for those columns
                    </p>
                </div>
                <hr />
                {/* Content */}
                <div
                    id="filterWrapper"
                    className="w-full h-full grid overflow-x-auto show-scrollbar">
                    <div className="mb-3 w-full">
                        <div className="flex align-items-center mb-3">
                            <div>
                                <h5 className="mb-0 font-semibold">
                                    Default Column Headers
                                </h5>
                            </div>
                        </div>
                        <table
                            className="m-2 w-full"
                            style={{borderCollapse: 'collapse'}}>
                            <thead>{renderHeaderTable()}</thead>
                            <tbody>{renderBodyTable()}</tbody>
                        </table>
                    </div>
                </div>

                {/* Footer */}
                <div className="my-2 w-full">
                    <Button
                        label={translateDatatable('Close').toUpperCase()}
                        icon="pi pi-times"
                        className="col-12 p-button-lg p-button-outlined font-bold mb-2"
                        onClick={handleHideForm}
                    />
                </div>
            </div>
        </Sidebar>
    )
})

export default ColumnHeaderReference
